import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Navigation from './components/Navigation';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Disclaimer from './pages/Disclaimer';
import { theme } from './styles/theme';
import Profile from './pages/Profile';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: ${theme.colors.background};
`;

const App: React.FC = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <AppContainer>
        <Navigation />
        <Routes>
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/" element={<Disclaimer />} />
        </Routes>
      </AppContainer>
    </Router>
  );
};

export default App;